






































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { jumpToNote } from "@/utils/hybird";
// import VueAwesomeSwiper from 'vue-awesome-swiper'

// Vue.use(VueAwesomeSwiper)

interface ImgObj {
  imgSrc: string;
  title: string;
  id: string;
}

interface Driver {
  name: string;
  src: string;
  desc: string;
  active: boolean;
}

// interface SwiperOptions {
//     loop:boolean;
//     slidesPerView:string;
//     centeredSlides:boolean;
//     autoplay:boolean;
//     pagination:{
//         el:string;
//         dynamicBullets:boolean;
//     };
//     on:{
//         slideChange:Function;
//     };

// }

function scrollFunc(){
    let timer:any = null;
    return function(func:any){
      if(timer)return;
      timer = setTimeout(()=>{
          clearTimeout(timer);
          timer = null;
          func&&func();
      },500)
    }
}

let swiper: any = null;
let vm: any = null;

@Component<VDRIVERPOINT>({})
export default class VDRIVERPOINT extends Vue {
  public title!: string;
  public activeIndex: number = 0;
  public timer: any = null;
  public swiperList: any = [];
  public dotList:any = [{active:true},{active:false}];
  public mounted() {
    vm = this;
    let imgList = this.$refs.imgList as any;
    let imgItem = imgList.querySelector('img');
    let imgItemW = imgItem.clientWidth;
    let imgListW = imgList.clientWidth;
    let maxScrollLeft = imgItemW - imgListW;
    let scrollCallback = scrollFunc();
    imgList.onscroll = function(e:any){
        scrollCallback(()=>{
            if(this.scrollLeft >= maxScrollLeft/2){
              vm.$set(vm.dotList[1],'active',true);
              vm.$set(vm.dotList[0],'active',false);
            }else {
              vm.$set(vm.dotList[1],'active',false);
              vm.$set(vm.dotList[0],'active',true);
            }
        })
    }
  }
  public jumpToNote(id: any) {
    jumpToNote(id);
  }
  public chooseDriver(index: number) {
    this.activeIndex = index;
    swiper.slideTo(index);
  }
}
